import React, { useState, useEffect } from 'react'
import { FormGroup, Panel, Input, Row, Col, Checkbox } from 'rsuite'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import HTMLWidget from '../../../widgets/HTMLWidget'

export default function ProposalReviseForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
  isSendBackNew,
}) {
  const [schema, setSchema] = useState(_schema)

  const onCheckChange = (id, value, subItems, index) => {
    // console.log('id', id, 'value', value, 'subItems', subItems, index)
    if (!value) {
      setValue(id, '')
      clearErrors(id)
    }

    setSchema((_state) => {
      let state = [..._state]
      let isMatch = false
      const updateValue = (arr) => {
        if (!arr || isMatch) {
          return
        }

        for (const item of arr) {
          if (item.id === id) {
            item.selected = value
            item.enableInput = value
            if (!value) {
              item.value = null
              if (item.subItems) {
                for (const subitem of item.subItems) {
                  subitem.selected = value
                  subitem.enableInput = value
                  subitem.value = null
                }
              }
            }
            isMatch = true
            return
          }

          updateValue(item.subItems)
        }
      }
      updateValue(state)
      setValue('requestBody', state)
      return state
    })
  }

  const onValueChange = (id, value, subItems, index) => {
    // console.log('onValueChange id', id, 'value', value, 'subItems', subItems, index)

    let _schema = [...schema]
    let isMatch = false
    const updateValue = (arr) => {
      if (!arr || isMatch) {
        return
      }

      for (const item of arr) {
        if (item.id === id) {
          item.value = value
          isMatch = true
          return
        }

        updateValue(item.subItems)
      }
    }
    updateValue(_schema)

    setValue('requestBody', _schema)
    setSchema(_schema)
    //   return state
    // })
  }

  const renderPanel = (panel, index) => {
    return (
      <Panel header={panel.label} collapsible defaultExpanded key={panel.id}>
        <>
          {panel.subItems.map((subject, index) => {
            return renderSubject(subject, index)
          })}
        </>
      </Panel>
    )
  }

  const renderSubject = (subject, index) => {
    return (
      <Row key={subject.id} style={{ marginTop: 10 }}>
        <Col md={1} style={{ marginTop: -10 }}>
          <Controller
            key={subject.id + '_checked'}
            name={subject.id + '_checked'}
            control={control}
            defaultValue={subject.selected}
            render={(props) => {
              return (
                <Checkbox
                  style={{ marginTop: '12px' }}
                  value={subject.selected}
                  checked={subject.selected}
                  onChange={(e, checked) => {
                    props.onChange(checked)
                    onCheckChange(subject.id, checked, subject, index)
                  }}
                  disabled={subject.disabledUnSelect}
                ></Checkbox>
              )
            }}
          />
        </Col>
        <Col md={23} style={{ padding: '0px', marginTop: -10 }}>
          <Panel
            header={subject.label}
            collapsible
            defaultExpanded
            expanded={subject.selected}
            onSelect={() => onCheckChange(subject.id, !subject.selected, subject, index)}
          >
            <FormGroup>
              {subject.subItems.length === 0 ? (
                <>
                  {subject.enableInput ? (
                    <>
                      {errors[subject.id] && (
                        <div style={{ marginTop: -10, marginBottom: 10 }}>
                          <ErrorMessage error={errors[subject.id]} />
                        </div>
                      )}
                      <Input
                        name={subject.id}
                        componentClass="textarea"
                        rows={3}
                        style={{ width: '100%', resize: 'auto', marginTop: 0 }}
                        placeholder={
                          subject.placeholder ||
                          `ระบุ ความคิดเห็น, เหตุผล, ข้อเสนอแนะ การแก้ไข ${subject.label}`
                        }
                        defaultValue={subject.value}
                        disabled={!subject.enableInput}
                        inputRef={register(
                          !isSendBackNew && {
                            required: subject?.selected
                              ? `กรุณาระบุ ความคิดเห็น, เหตุผล, ข้อเสนอแนะ การแก้ไข ${subject.label}`
                              : false,
                          }
                        )}
                        onChange={(value) => {
                          onValueChange(subject.id, value, subject, index)
                        }}
                      />
                    </>
                  ) : (
                    <HTMLWidget data={subject.value} />
                  )}
                </>
              ) : (
                <>
                  {subject.subItems.map((sub, index) => {
                    return renderSub(sub, index)
                  })}
                </>
              )}
            </FormGroup>
          </Panel>
        </Col>
      </Row>
    )
  }

  const renderSub = (sub, index) => {
    return (
      <Row key={index}>
        <Controller
          key={sub.id + '_checked'}
          name={sub.id + '_checked'}
          control={control}
          defaultValue={sub.selected}
          render={(props) => {
            return (
              <Checkbox
                // style={{ marginTop: '0px', fontSize: '0.9rem' }}
                value={sub.projectFeedbackId}
                checked={sub.selected}
                onChange={(e, checked) => {
                  props.onChange(checked)
                  onCheckChange(sub.id, checked, sub, index)
                }}
                disabled={sub.disabledUnSelect}
              >
                {sub.label}
              </Checkbox>
            )
          }}
        />
        {sub.selected && (
          <Row style={{ marginLeft: 30 }}>
            {sub.enableInput ? (
              <>
                {' '}
                {errors[sub.id] && (
                  <div style={{ marginTop: -10, marginBottom: 10 }}>
                    <ErrorMessage error={errors[sub.id]} />
                  </div>
                )}
                <Input
                  name={sub.id}
                  componentClass="textarea"
                  defaultValue={sub.value}
                  disabled={!sub.enableInput}
                  placeholder={
                    sub.placeholder || `ระบุ ความคิดเห็น, เหตุผล, ข้อเสนอแนะ การแก้ไข ${sub.label}`
                  }
                  inputRef={register(
                    !isSendBackNew && {
                      required: sub?.selected
                        ? `กรุณาระบุ ความคิดเห็น, เหตุผล, ข้อเสนอแนะ การแก้ไข ${sub.label}`
                        : false,
                    }
                  )}
                  onChange={(value) => {
                    onValueChange(sub.id, value, sub, index)
                  }}
                />
              </>
            ) : (
              <HTMLWidget data={sub.value} />
            )}
          </Row>
        )}
      </Row>
    )
  }

  return (
    <>
      <Controller
        key={'requestBody'}
        name={'requestBody'}
        control={control}
        defaultValue={schema}
      />
      {schema &&
        schema.map((panel, index) => {
          return renderPanel(panel, index)
        })}
    </>
  )
}
